<div class="contractor-exit-wrapper" [ngSwitch]="templateId">
  <ng-container *ngSwitchCase="'exit'">
    <ng-container *ngTemplateOutlet="exit"></ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="'restart'">
    <ng-container *ngTemplateOutlet="restart"></ng-container>
  </ng-container>
</div>

<ng-template #exit>
  <div class="exit-box-title">
    {{ 'onboarding.exit.header' | translate }}
  </div>
  <div class="exit-box-sub-title">
    {{ 'onboarding.exit.body' | translate }}
  </div>

  <div class="btns">
    <button
      type="submit"
      mat-raised-button
      cg-mat-btn-type="primary"
      class="yes-btns"
      data-test-id="btn-submit"
      (click)="onExitYesClicked()"
    >
      Yes
    </button>
    <button
      mat-raised-button
      class="no-btns"
      data-test-id="btn-cancel"
      (click)="onExitNoClicked()"
    >
      No
    </button>
  </div>
</ng-template>

<ng-template #restart>
  <div class="error-box-title">
    {{ 'onboarding.noLob.header' | translate }}
  </div>
  <div class="exit-box-sub-title">
    {{ 'onboarding.noLob.body' | translate }}
  </div>

  <div class="btns">
    <button
      type="submit"
      mat-raised-button
      cg-mat-btn-type="primary"
      class="restart-btns"
      data-test-id="btn-submit"
      (click)="onRestartClicked()"
    >
      {{ 'onboarding.noLob.restart' | translate }}
    </button>
    <button
      mat-raised-button
      class="exit-btns"
      data-test-id="btn-cancel"
      (click)="onExitClicked()"
    >
      {{ 'onboarding.noLob.exit' | translate }}
    </button>
  </div>
</ng-template>
